import React from 'react'
import styles from './styles.module.scss'

interface DottedBackgroundProps {
    height?: number
}

export default function DottedBackground({ height = 200 }: DottedBackgroundProps) {
    return (
        <div className={styles.wrapper} style={{ height }}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                className={styles.svg}
            >
                <defs>
                    <pattern id="dot-pattern" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                        <circle cx="2" cy="2" r="1.5" fill="#c8c8c8" fillOpacity="0.4" />
                    </pattern>
                </defs>
                <rect width="100%" height="100%" fill="url(#dot-pattern)" />
            </svg>
        </div>
    )
}
